import { BlogCategory } from "@/app/types/BlogCategory";
import styles from "./BlogCover.module.css";
import BlogCoverScores from "./BlogCoverScores";
import BlogCoverTags from "./BlogCoverTags";
import BlogCoverTools from "./BlogCoverTools";
import BlogCoverWave from "./BlogCoverWave";

type Props = {
  categoryId: string;
  seed: number;
};

export default function BlogCover(props: Props) {
  const { categoryId, seed } = props;

  return (
    <span className={styles.cover} aria-hidden="true">
      {categoryId === BlogCategory.CUSTOMER_KNOWLEDGE && <BlogCoverTags seed={seed} />}
      {categoryId === BlogCategory.WIN_LOSS && <BlogCoverScores seed={seed} />}
      {categoryId === BlogCategory.AI_TOOLS && <BlogCoverTools />}
      {categoryId === BlogCategory.CALL_ANALYSIS && <BlogCoverWave seed={seed} />}
    </span>
  );
}
